import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Facebook, 
  Twitter, 
  Instagram, 
  LinkedIn, 
  YouTube, 
  LocationOn, 
  Phone, 
  Email, 
  Schedule 
} from '@mui/icons-material';

const Footer = () => {

  return (
    <footer className="bg-blue-900 text-white py-10">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row md:justify-between gap-12 md:gap-0">
          <div className="mb-8 md:mb-0">
            <Link to="/" className="mb-4 block">
              <h3 className="text-2xl font-bold m-0">Moxie Master</h3>
              <span className="text-gray-200 text-sm">Public School</span>
            </Link>
            <p className="text-gray-300 max-w-xs mb-4">Empowering students for a brighter tomorrow through excellence in education, character development, and global citizenship.</p>
            <div className="flex gap-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors"><Facebook /></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors"><Twitter /></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors"><Instagram /></a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors"><LinkedIn /></a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors"><YouTube /></a>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            <div>
              <h4 className="text-lg font-semibold mb-4">Contact</h4>
              <div className="flex items-center gap-2 mb-2"><LocationOn className="text-yellow-400" /><span>123 Education Street, Pune City</span></div>
              <div className="flex items-center gap-2 mb-2"><Phone className="text-yellow-400" /><span>+91 83590 87358</span></div>
              <div className="flex items-center gap-2 mb-2"><Email className="text-yellow-400" /><span>rohanrathi.dev@gmail.com</span></div>
              <div className="flex items-center gap-2"><Schedule className="text-yellow-400" /><span>Mon-Fri: 8am - 4pm</span></div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="hover:text-yellow-400 transition-colors">Home</Link></li>
                <li><Link to="/academics" className="hover:text-yellow-400 transition-colors">Academics</Link></li>
                <li><Link to="/admissions" className="hover:text-yellow-400 transition-colors">Admissions</Link></li>
                <li><Link to="/facilities" className="hover:text-yellow-400 transition-colors">Facilities</Link></li>
                <li><Link to="/gallery" className="hover:text-yellow-400 transition-colors">Gallery</Link></li>
                <li><Link to="/news-events" className="hover:text-yellow-400 transition-colors">News & Events</Link></li>
                <li><Link to="/contact" className="hover:text-yellow-400 transition-colors">Contact</Link></li>
                <li><Link to="/terms-conditions" className="hover:text-yellow-400 transition-colors">Terms & Conditions</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-10 text-center text-gray-400 text-sm">&copy; {new Date().getFullYear()} Moxie Master Public School. All rights reserved.</div>
      </div>
    </footer>
  );
};

export default Footer; 